module.exports = "../../../../platform/assets/pageMainIcon/industry_yewuchulilei3.svg";